module.exports = __webpack_public_path__ + "img/house_26.76853ffb.jpg";